import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/components/tutorial.css';

function Tutorial() {
  const { t } = useTranslation();

  return (
    <div className="tutorial-page">
      <h1>{t('tutorial.title')}</h1>
      <p>{t('tutorial.subtitle')}</p>
      
      <div className="video-container">
        <div className="video-placeholder">
          <button className="play-button">▶</button>
          <img src="/path-to-video-thumbnail.jpg" alt={t('tutorial.video.thumbnail')} />
        </div>
      </div>
      
      <div className="steps-section">
        <h2>{t('tutorial.steps.title')}</h2>
        
        <div className="step">
          <div className="step-number">1</div>
          <div className="step-content">
            <h3>{t('tutorial.steps.step1.title')}</h3>
            <p>{t('tutorial.steps.step1.description')}</p>
          </div>
        </div>
        
        <div className="step">
          <div className="step-number">2</div>
          <div className="step-content">
            <h3>{t('tutorial.steps.step2.title')}</h3>
            <p>{t('tutorial.steps.step2.description')}</p>
          </div>
        </div>
        
        <div className="step">
          <div className="step-number">3</div>
          <div className="step-content">
            <h3>{t('tutorial.steps.step3.title')}</h3>
            <p>{t('tutorial.steps.step3.description')}</p>
          </div>
        </div>
        
        <div className="step">
          <div className="step-number">4</div>
          <div className="step-content">
            <h3>{t('tutorial.steps.step4.title')}</h3>
            <p>{t('tutorial.steps.step4.description')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tutorial;